'use client';

import { StoneInvestmentJournalSection, type Article } from '@routeroyal/theme-stone-investment';

type Props = {
  locale: string;
  articles: Article[];
  messages?: Record<string, unknown>;
};

export type { Article };

/**
 * Stone Investment Blog/Journal Content
 * 
 * Uses the Concept One Journal design with:
 * - Editorial header with category filters
 * - Featured article with floating card overlay
 * - Grid layout with different styles per category
 * - MARKET articles get horizontal layout
 * - Standard articles get vertical/editorial layout
 */
export function BlogListingContentStone({ locale, articles, messages }: Props) {
  return (
    <StoneInvestmentJournalSection
      articles={articles}
      articleBasePath={`/${locale}/news`}
      locale={locale}
      messages={messages || {}}
    />
  );
}
